<div class="container-fluid">
    <div class="d-grid main">
      <div class="logo p-10">
        <img
          src="assets/img/menu-3(24x24)@3x.png"
          alt="GetVantage Tech Private Limited"
          loading="lazy"
          width="200px"
        />
        <!-- <img src="../../../assets/img/instagram icon.png" width="40px" class="f-right" loading="lazy" alt="GetVantage Tech"> -->
      </div>
      <div class="d-grid parts">
        <div class="left">
          <img src="../../../assets/img/Finance app_Flatline.svg" style="border-right: 1px solid #ddd;" class="mt-20" loading="lazy" alt="left banner" />
        </div>
        <div class="right">
          <form (ngSubmit)="onSubmit()">
            <h2 class="mb-20">Forgot Password :(</h2>
            <div class="input-fields">
              <div class="field field1 d-grid">
                <div class="input-logo">
                  <img
                    src="../../../assets/img/mail(24x24)@2x.png"
                    width="80%"
                    loading="lazy"
                    alt="email"
                  />
                </div>
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  autofocus
                  [(ngModel)]="email"
                />
              </div>
              <p><a routerLink='/login'><small>Back to Login?</small></a></p>
            </div>
            <button type="submit" class="primary-btn ripple">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  